<template>
  <div class="page-header mb-1 mb-md-2">
    <!-- showBackButton är true eller false. Använd den för att veta vilken styling du ska ta  -->
    <div
      class="d-flex flex-row align-items-center justify-content-between mb-1 pb-1 border-bottom"
    >
      <slot v-if="!isHomepage" name="back-link">
        <b-button
          v-if="showBackButton"
          @click="back()"
          variant="primary"
          class="link-back"
        >
          <i class="fas fa-arrow-left fa-fw"></i>
        </b-button>
      </slot>
      <div v-if="isHomepage" class="page-title">
        <b-navbar-nav>
          <b-nav-item-dropdown id="dropdown-offset" offset="20" right>
            <template #button-content>
              <!-- <h3 v-if="this.pageTitle">{{ pageTitle }}</h3> -->
              <h3>{{ $route.meta.pageTitle }}</h3>
            </template>
            <b-dropdown-item href="#" @click="onDropdownItemClicked"
              >Använd den här sidan som startsida</b-dropdown-item
            >
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </div>
      <div v-else class="page-title">
        <h3 v-if="this.pageTitle">{{ pageTitle }}</h3>
        <h3 v-else>{{ $route.meta.pageTitle }}</h3>
        <!-- <h3>{{ $route.meta.pageTitle }}</h3> -->
      </div>

      <div class="actions">
        <slot name="actions"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BNavItemDropdown,
  BDropdownItem,
  BNavbarNav,
  BButton,
} from "bootstrap-vue";
import { mapActions } from "vuex";

export default {
  name: "PageHeader",
  props: {
    pageTitle: String,
  },
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BNavbarNav,
    BButton,
  },

  data() {
    return {
      prevRoute: null,
      isHomepage: false,
      homepage: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    const isExternal = from.name === null;
    next((vm) => {
      vm.isExternal = isExternal;
    });
  },
  mounted() {
    this.$nextTick(async () => {
      if (this.$route.name !== null) {
        let page = this.pageTitle ? this.pageTitle : this.$route.meta.pageTitle;
        this.homepages = await this.fetchHomepages();
        this.homepages.forEach((element) => {
          if (element.title == page) {
            this.isHomepage = true;
            this.homepage = element;
          }
        });
      }
    });
  },

  computed: {
    showBackButton() {
      return !this.isExternal && this.$router.currentRoute.name !== 'home';
    },
  },
  methods: {
    ...mapActions(["fetchHomepages", "fetchHomepage"]),
    back() {
      if (this.$route.name !== "home")
         this.$router.go(-1);
    },
    getBaseURL(url) {
      const urlParts = url ? url.split("/") : "/";
      return `${urlParts[2]}`;
    },
    onDropdownItemClicked() {
      const payload = {
        userId: this.$currentUserId(),
        homepage: this.homepage,
      };

      this.$store.dispatch("updateHomepage", payload);
    },
  },
};
</script>

<style scope>
h3 {
  display: contents;
  margin-bottom: 0;
  padding-bottom: 0;
}
.dropdown-toggle::after {
  background-size: 24px;
  margin-bottom: 2px;
}
</style>
